<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="formDialogVisible"
    width="800px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="form">
      <el-form ref="form" :rules="rules" :model="form" label-width="160px">
        <el-row :gutter="24">
          <el-col :span="18">
            <el-form-item label="车辆" prop="carId">
              <el-select
                @change="GetCarDetail"
                filterable
                v-model="form.carId"
                placeholder="请选择"
                :disabled="type === 'detail'"
                size="large"
              >
                <el-option
                  v-for="item in carList"
                  :key="item.id"
                  :label="item.frame_num"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form ref="form" :model="form">
          <el-table :data="form.item" max-height="250" border>
            <el-table-column align="center" prop="serviceTypeName" label="服务">
            </el-table-column>

            <el-table-column align="center" prop="unit" label="单位">
              <template #default="scope">
                <el-form-item
                  :inline-message="true"
                  :prop="'item.' + scope.$index + '.unit'"
                  :rules="rules.unit"
                >
                  <el-select
                    v-model="scope.row.unit"
                    placeholder="请选择"
                    :disabled="type === 'detail'"
                    size="large"
                  >
                    <el-option
                      v-for="item in unitArray"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    />
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>

            <el-table-column align="center" prop="num" label="数量">
              <template #default="scope">
                <el-form-item
                  :inline-message="true"
                  :prop="'item.' + scope.$index + '.num'"
                  :rules="rules.num"
                >
                  <el-input
                    v-model="scope.row.num"
                    placeholder="请输入数量"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <el-row :gutter="24" style="margin-top: 20px;">
          <el-col :span="18">
            <el-form-item label="金额（元）" prop="amount">
              <el-input v-model="form.amount" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer v-if="type !== 'detail'">
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="submitForm('form')">
          保存
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { addOrder } from '@/api/order';
import { FormValidators } from '@/utils/validate';

import { GetCarList, GetCarDetail } from '@/api/car';
const titleMap = new Map([
  ['add', '新建'],
  ['edit', '编辑'],
  ['detail', '详情'],
]);
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formDialogVisible: false,
      carList: [],
      dialogTitle: '',
      rules: {
        carId: [
          {
            required: true,
            message: '请选择车辆!',
            trigger: ['blur', 'change'],
          },
        ],
        amount: [
          { required: true, message: '请输入金额!', trigger: 'blur' },
          {
            validator: FormValidators.numberOrPoint,
            message: '请输入数字',
            trigger: 'blur',
          },
        ],
        num: [
          {
            validator: FormValidators.negativeOrPositiveInt,
            message: '请输入整数',
            trigger: 'blur',
          },
        ],
      },
      form: {
        carId: '',
        amount: '',
        item: [],
      },
      unitArray: [
        {
          key: 1,
          value: '日',
        },
        {
          key: 2,
          value: '月',
        },
        {
          key: 3,
          value: '年',
        },
      ],
    };
  },
  created() {
    // this.initFormData();
  },
  watch: {
    // 显示隐藏双向绑定
    visible(val) {
      this.formDialogVisible = val;
      if (val) {
        this.initFormData();
      }
    },
    formDialogVisible(val) {
      this.$emit('visible-change', val);
    },
    type(val) {
      // 获取类型
      if (val) {
        this.dialogTitle = titleMap.get(val);
      }
    },
  },
  methods: {
    GetCarDetail(e) {
      // 获取车辆详情
      GetCarDetail({ id: e }).then((res) => {
        this.form.item = res.data.hardware.map((item) => {
          return {
            hardwareId: item.id,
            serviceTypeName: item.serviceTypeName,
            unit: '',
            num: '',
          };
        });
      });
    },
    handleClose() {
      this.formDialogVisible = false;
      this.form.item = [];
      this.$refs['form'].resetFields();
    },

    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //   const fn = this.id ? updateAppUser : addOrder;
          addOrder(this.form).then((res) => {
            if (res.code == 0) {
              this.$message.success('保存成功!');
              this.handleClose();
              this.$emit('success');
            }
          });
        }
      });
    },
    //非空判断
    isNotEmpty(str) {
      if (str != null && str != '' && str.trim().length > 0) {
        return true;
      }
      return false;
    },
    async initFormData() {
      const { data } = await GetCarList({
        start: 1,
        size: 1000,
      });
      this.carList = data.content;
      if (this.id) {
        this.getDetail();
      }
    },
    getDetail() {
      //   getAppUserDetail(this.id).then((res) => {
      //     if (res.code == 0) {
      //       res.data.bindVehicles = res.data.bindCardList.map((item) => {
      //         return item.carId;
      //       });
      //       this.form = res.data;
      //     } else {
      //       let msg = res.message;
      //       this.$message.error(this.isNotEmpty(msg) ? msg : '查询异常!');
      //     }
      //   });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  //   height: 500px;
  //   overflow-y: scroll;
}
/deep/.el-select,
.el-date-editor {
  width: 100%;
}
</style>
